export default __webpack_public_path__ + "static/media/DSC_0565.a8e90222.jpg";